<template>
    <div class="e2e-grid">
        <div>
             <!-- ROW -->
            <div v-for="(row,rowIndex) in fragment.rows"
                :key="rowIndex"
                class="row">
                <!-- CELL -->
                <div v-for="(cell,cellIndex) in row.cells"
                    :key="cellIndex"
                    :class="'col-sm-' + (cell.space * 2)">
                      <!-- CELL CONTENT -->
                      <div  :fragment="cell.content"
                            v-if="cell.content"
                            :is="resolveFragmentComponentName(cell.content)">
                      </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { resolveFragmentComponentName } from "./output-fragment-resolver.js";

export default {
  name: "fragment-grid",
  props: ["fragment"],
  methods: {
    resolveFragmentComponentName
  }
};
</script>
 

<style scoped>
</style>